// extracted by mini-css-extract-plugin
module.exports = {"boundary":"InfoTooltip_boundary__OT0XB","infoIconButton":"InfoTooltip_infoIconButton__R2Ue_","inverse":"InfoTooltip_inverse__nqiiS"};